import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RuleBaseModelStrict} from '../../../models/api/ruleModel';
import {getRuleType} from '../list/ruleBundleCategory';
import {getRuleTypeIcon, getRuleTypePaletteColor} from '../list/ruleBundleCategoryStyles';

/*
 * Type.
 */

interface RuleListIconProps {
  rule: RuleBaseModelStrict;
}

/*
 * Styles.
 */

export const StyledRuleListIconWrapper = styled.div<{$backgroundColor: string; $color: string}>`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: ${(p) => p.$backgroundColor};
  color: ${(p) => p.$color};
`;

/*
 * Component.
 */

export const RuleListIcon = ({rule}: RuleListIconProps) => {
  const theme = useUserTheme();
  const ruleType = getRuleType(rule);
  const iconName = getRuleTypeIcon(ruleType).regular.filled;
  const iconColor = theme.palette[getRuleTypePaletteColor(ruleType)];

  return (
    <StyledRuleListIconWrapper $backgroundColor={iconColor.shade20} $color={iconColor.shade40}>
      <Icon name={iconName} color={iconColor.shade40} />
    </StyledRuleListIconWrapper>
  );
};
